"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserLocalStorageKeyStore = void 0;
var keystores_browser_1 = require("@near-js/keystores-browser");
Object.defineProperty(exports, "BrowserLocalStorageKeyStore", { enumerable: true, get: function () { return keystores_browser_1.BrowserLocalStorageKeyStore; } });
